import ContestInfoContainer from "./contest-info-container.tsx";
import { openContestTerms } from "state/slices/legal-modal-slice.ts";
import { useAppDispatch } from "state/hooks.ts";
import { setSelectedContest } from "state/slices/group-slice.ts";
import { Contest } from "interfaces/leaderboard/contest.ts";

interface Props {
  prizeValue: string;
  contest: Contest;
}

const PrizeValueDisplay = ({ prizeValue, contest }: Props) => {
  const dispatch = useAppDispatch();

  const handleClick = (event: React.MouseEvent) => {
    event.stopPropagation();
    dispatch(setSelectedContest(contest));
    dispatch(openContestTerms());
  };

  return (
    <div onClick={handleClick} style={{ cursor: "pointer", width: 100, textAlign: "center" }}>
      <ContestInfoContainer
        topText={prizeValue}
        bottomText="Prize Value"
        topTextColor="var(--sparket-green)"
        maxWidth={100}
        underline
      />
    </div>
  );
};

export default PrizeValueDisplay;
